import React from 'react'

interface CsIconProps extends React.SVGProps<SVGSVGElement> {
  title?: string
}

export const CsIcon = (props: CsIconProps) => {
  return (
    <svg
      width="22"
      height="23"
      viewBox="0 0 22 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>{props?.title}</title>
      <g clipPath="url(#clip0_12114_94755)">
        <path d="M1 1.19922H21V11.1992H1V1.19922Z" fill="white" />
        <path d="M1 11.1992H21V21.1992H1V11.1992Z" fill="#D7141A" />
        <path
          d="M12.7188 11.1992L1 3.38672V19.0117L12.7188 11.1992Z"
          fill="#11457E"
        />
      </g>
      <path
        d="M11 0.699219C16.799 0.699219 21.5 5.40023 21.5 11.1992C21.5 16.9982 16.799 21.6992 11 21.6992C5.20101 21.6992 0.5 16.9982 0.5 11.1992C0.5 5.40023 5.20101 0.699219 11 0.699219Z"
        stroke="#D6D8DC"
      />
      <defs>
        <clipPath id="clip0_12114_94755">
          <path
            d="M1 11.1992C1 5.67637 5.47715 1.19922 11 1.19922C16.5228 1.19922 21 5.67637 21 11.1992C21 16.7221 16.5228 21.1992 11 21.1992C5.47715 21.1992 1 16.7221 1 11.1992Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
